import React from 'react';

import { BrowserRouter } from "react-router-dom";
import NavBar from '../NavBar/NavBar';
import FamilyBanner from '../FamilyBanner/FamilyBanner';
import RoutedContent from '../RoutedContent/RoutedContent';
import NewHome from "../NewHome/newHome.tsx";

/*
function App() {
    return (
        <div>
            <NavBar />
            <div className="page-wrapper">
                //<FamilyBanner />
                //<RoutedContent />
                <NewHome />
            </div>
        </div>
    );
}*/

function App() {
  return (
    <div>
      <NewHome />
    </div>
  );
}

export default App;
